// Landing Page Settings and Feature Flags
// This file controls various settings for the landing page and sign-up flow

export const landingSettings = {
  // Promo Code Settings
  promo: {
    enabled: true, // Set to false to disable promo code functionality
    code: 'SCREAMIFY25',
    trialDays: 30,
    displayText: '30-day free trial',
    description: 'Then $2.99/month after trial',
    endDate: '2025-09-01' // YYYY-MM-DD format (update this to control countdown)
  },
  
  // Future settings can be added here
  // Example:
  // specialOffer: {
  //   enabled: false,
  //   discount: 50,
  //   expiryDate: '2025-12-31'
  // }
};

// Export individual settings for convenience
export const isPromoEnabled = () => landingSettings.promo.enabled;
export const getPromoCode = () => landingSettings.promo.code;
export const getPromoTrialDays = () => landingSettings.promo.trialDays;

// Calculate days remaining until promo expires
export const getPromoDaysRemaining = () => {
  if (!landingSettings.promo.endDate) return null;
  
  const now = new Date();
  const endDate = new Date(landingSettings.promo.endDate);
  
  // Set both dates to midnight for accurate day calculation
  now.setHours(0, 0, 0, 0);
  endDate.setHours(0, 0, 0, 0);
  
  const diffTime = endDate - now;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  
  // Return null if promo has expired
  return diffDays > 0 ? diffDays : 0;
}; 

// Validate against multiple acceptable promo codes while keeping a single displayed code
export const isValidPromo = (code) => {
  const entered = (code || '').toUpperCase();
  // Add/remove secondary accepted promo codes below. The first entry
  // uses the primary displayed code from landingSettings.promo.code.
  // To change the secondary code, edit the string (e.g., 'WITCH25').
  const allowed = [
    (landingSettings.promo.code || '').toUpperCase(),
    'WITCH25' // Secondary accepted code (edit this if you change it)
  ];
  return !!entered && allowed.includes(entered);
};